<main class="login-shell">
  <section class="login-brand-panel">
    <div class="login-grid"></div>
    <div class="login-brand-glow"></div>

    <header class="login-logo login-fade-up">
      <div class="login-logo-mark">
        <img src="workwell-logo.jpg" alt="WorkWell" />
      </div>
      <div class="login-logo-text">WorkWell</div>
    </header>

    <div class="login-copy login-fade-up-delay-1">
      <div class="login-pill">
        <span></span>
        Live Xero & Evertime finance data
      </div>

      <h1>Finance<br />Admin Login</h1>

      <p>
        Sign in to access the WorkWell finance dashboard — real-time KPIs,
        cash flow.
      </p>
    </div>

    <div class="login-chart login-fade-up-delay-2">
      <svg viewBox="0 0 760 210" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="loginTrendFill" x1="0" y1="42" x2="0" y2="210" gradientUnits="userSpaceOnUse">
            <stop stop-color="#21C7A8" stop-opacity="0.24" />
            <stop offset="1" stop-color="#21C7A8" stop-opacity="0" />
          </linearGradient>
        </defs>
        <path class="login-trend-area"
          d="M20 154 L130 98 L240 176 L350 52 L470 145 L580 110 L690 78 L760 38 L760 210 L20 210 Z"
          fill="url(#loginTrendFill)" />
        <path class="login-trend-line" pathLength="1"
          d="M20 154 L130 98 L240 176 L350 52 L470 145 L580 110 L690 78 L760 38" stroke="#21C7A8" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round" />
        <circle class="login-trend-dot-glow" cx="760" cy="38" r="11" fill="#35e6bc" />
        <circle class="login-trend-dot" cx="760" cy="38" r="4.5" fill="#35e6bc" />
      </svg>
    </div>

    <footer class="login-footer">Powered By WorkWell</footer>
  </section>

  <section class="login-form-panel">
    <div class="login-card login-fade-up">
      <h2>Sign in</h2>
      <p class="login-card-subtitle">Enter your credentials to access the finance workspace.</p>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="login-field">
          <label for="login-email">Email or username</label>
          <div class="login-input-wrap">
            <i class="pi pi-envelope"></i>
            <input id="login-email" type="text" formControlName="emailOrUserName" placeholder="dev.admin@workwell.local"
              autocomplete="username" autofocus />
          </div>
          @if (form.controls.emailOrUserName.dirty && form.controls.emailOrUserName.touched && form.controls.emailOrUserName.invalid) {
          <p class="login-error-text">Enter your email or username.</p>
          }
        </div>

        <div class="login-field">
          <label for="login-password">Password</label>
          <div class="login-input-wrap">
            <i class="pi pi-lock"></i>
            <input id="login-password" [type]="showPassword() ? 'text' : 'password'" formControlName="password"
              placeholder="Enter password" autocomplete="current-password" />
            <button type="button" class="login-icon-button" (click)="showPassword.set(!showPassword())" tabindex="-1"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
              <i class="pi" [ngClass]="showPassword() ? 'pi-eye-slash' : 'pi-eye'"></i>
            </button>
          </div>
        </div>

        <label class="login-remember">
          <input type="checkbox" formControlName="rememberMe" />
          <span>Remember me</span>
        </label>

        @if (error()) {
        <div class="login-error">
          <i class="pi pi-exclamation-circle"></i>
          <p>{{ error() }}</p>
        </div>
        }

        <button class="login-submit" type="submit" [disabled]="form.invalid || loading()">
          @if (loading()) {
          <i class="pi pi-spin pi-spinner"></i>
          <span>Signing in...</span>
          } @else {
          <span>Sign In</span>
          }
        </button>
      </form>
    </div>
  </section>
</main>

@if (tenants().length > 0) {
<div class="tenant-modal-backdrop" role="presentation">
  <section class="tenant-modal" role="dialog" aria-modal="true" aria-labelledby="tenant-modal-title">
    <div class="tenant-modal-header">
      <div><h2 id="tenant-modal-title">Choose a tenant</h2><p>Select the workspace you want to open.</p></div>
      <button type="button" class="tenant-modal-close" (click)="closeTenantModal()" [disabled]="!!selectingTenantId()" aria-label="Close tenant selection"><i class="pi pi-times"></i></button>
    </div>
    <div class="tenant-list">
      @for (tenant of tenants(); track tenant.tenantId || tenant.tenant_id || tenant.id || $index) {
      <button type="button" class="tenant-option" (click)="selectTenant(tenant)" [disabled]="!!selectingTenantId()">
        <span class="tenant-option-icon"><i class="pi pi-building"></i></span>
        <span class="tenant-option-copy"><strong>{{ tenantName(tenant) }}</strong></span>
        <i class="pi" [ngClass]="selectingTenantId() === (tenant.tenantId || tenant.tenant_id || tenant.id) ? 'pi-spin pi-spinner' : 'pi-chevron-right'"></i>
      </button>
      }
    </div>
    @if (error()) { <div class="login-error tenant-modal-error"><i class="pi pi-exclamation-circle"></i><p>{{ error() }}</p></div> }
  </section>
</div>
}
